import { Controller } from "@hotwired/stimulus"

// Re-prices the deal drawer from the server as its terms are typed, so the
// total on screen is the one Stripe will bill rather than an estimate the
// form works out for itself.
//
//   <div data-controller="deal-quote" data-deal-quote-url-value="/…/deal/quote"
//        data-action="input->deal-quote#refresh">
//     <input name="deal[seats]">
//     <div data-deal-quote-target="output">…</div>
//   </div>
export default class extends Controller {
  static targets = ["output"]
  static values = { url: String }

  declare readonly outputTarget: HTMLElement
  declare readonly urlValue: string

  private timer?: ReturnType<typeof setTimeout>
  private pending = 0

  refresh(): void {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.load(), 250)
  }

  disconnect(): void {
    clearTimeout(this.timer)
  }

  private async load(): Promise<void> {
    const form = this.element.closest("form")
    if (!form) return

    const params = new URLSearchParams()
    new FormData(form).forEach((value, key) => {
      if (key !== "_method" && key !== "authenticity_token") params.append(key, String(value))
    })

    // A slower earlier request must not overwrite a newer quote.
    const ticket = ++this.pending
    const response = await fetch(`${this.urlValue}?${params}`, { headers: { Accept: "text/html" } })
    if (!response.ok || ticket !== this.pending) return

    this.outputTarget.innerHTML = await response.text()
  }
}
